const CushionDiamond = ({ ...props }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
      fill="currentColor"
      {...props}
    >
      <path
        d="M70.06,94.38c0.01,0,0.01,0,0.02-0.01c5.81-1.71,11.16-4.98,15.08-9.21c4.23-3.92,7.51-9.27,9.21-15.08
	c0-0.01,0-0.01,0.01-0.02c0.81-2.75,1.22-5.46,1.22-8.06V38c0-2.6-0.41-5.31-1.22-8.06c0-0.01,0-0.01-0.01-0.02
	c-1.71-5.81-4.98-11.16-9.21-15.08c-3.92-4.23-9.27-7.51-15.08-9.21c-0.01,0-0.01,0-0.02-0.01C67.31,4.81,64.6,4.4,62,4.4H38
	c-2.6,0-5.31,0.41-8.06,1.22c-0.01,0-0.01,0-0.02,0.01c-5.81,1.71-11.16,4.98-15.08,9.21c-4.23,3.92-7.51,9.27-9.21,15.08
	c0,0.01,0,0.01-0.01,0.02C4.81,32.69,4.4,35.4,4.4,38v24c0,2.6,0.41,5.31,1.22,8.06c0,0.01,0,0.01,0.01,0.02
	c1.71,5.81,4.98,11.16,9.21,15.08c3.92,4.23,9.27,7.51,15.08,9.21c0.01,0,0.01,0,0.02,0.01c2.75,0.81,5.46,1.22,8.06,1.22h24
	C64.6,95.6,67.31,95.19,70.06,94.38z M5.74,50l10.31-14.06L29.18,50L16.06,64.06L5.74,50z M17.06,35.26l12.34-4.41v17.63
	L17.06,35.26z M29.4,51.52v17.63l-12.34-4.41L29.4,51.52z M30.6,30.6h38.8v38.8H30.6V30.6z M35.94,16.06L50,5.74l14.06,10.31
	L50,29.18L35.94,16.06z M48.48,29.4H30.85l4.41-12.34L48.48,29.4z M51.52,29.4l13.22-12.34l4.41,12.34H51.52z M94.26,50L83.94,64.06
	L70.82,50l13.12-14.06L94.26,50z M82.94,64.74L70.6,69.15V51.52L82.94,64.74z M70.6,48.48V30.85l12.34,4.41L70.6,48.48z M48.48,70.6
	L35.26,82.94L30.85,70.6H48.48z M50,70.82l14.06,13.12L50,94.26L35.94,83.94L50,70.82z M51.52,70.6h17.63l-4.41,12.34L51.52,70.6z
	 M62,94.4H51.83l12.95-9.5l4.26,8.52C66.64,94.07,64.27,94.4,62,94.4z M70.22,93.08l-4.23-8.45l17.38,0.65
	C79.84,88.76,75.13,91.55,70.22,93.08z M84.12,84.12l-18.28-0.68l4.63-12.96l12.96-4.63L84.12,84.12z M93.08,70.22
	c-1.53,4.92-4.32,9.62-7.8,13.15l-0.65-17.38L93.08,70.22z M94.4,62c0,2.27-0.33,4.64-0.98,7.05l-8.52-4.26l9.5-12.95V62z M94.4,38
	v10.17l-9.5-12.95l8.52-4.26C94.07,33.36,94.4,35.73,94.4,38z M93.08,29.78l-8.45,4.23l0.65-17.38
	C88.76,20.16,91.55,24.87,93.08,29.78z M83.43,34.16l-12.96-4.63l-4.63-12.96l18.28-0.68L83.43,34.16z M83.37,14.71l-17.38,0.65
	l4.23-8.45C75.13,8.45,79.84,11.24,83.37,14.71z M62,5.6c2.27,0,4.64,0.33,7.05,0.98l-4.26,8.52L51.83,5.6H62z M38,5.6h10.17
	l-12.95,9.5l-4.26-8.52C33.36,5.93,35.73,5.6,38,5.6z M29.78,6.92l4.23,8.45l-17.38-0.65C20.16,11.24,24.87,8.45,29.78,6.92z
	 M15.88,15.88l18.28,0.68l-4.63,12.96l-12.96,4.63L15.88,15.88z M6.92,29.78c1.53-4.92,4.32-9.62,7.8-13.15l0.65,17.38L6.92,29.78z
	 M5.6,38c0-2.27,0.33-4.64,0.98-7.05l8.52,4.26L5.6,48.17V38z M5.6,62V51.83l9.5,12.95l-8.52,4.26C5.93,66.64,5.6,64.27,5.6,62z
	 M6.92,70.22l8.45-4.23l-0.65,17.38C11.24,79.84,8.45,75.13,6.92,70.22z M16.57,65.84l12.96,4.63l4.63,12.96l-18.28,0.68
	L16.57,65.84z M16.63,85.29l17.38-0.65l-4.23,8.45C24.87,91.55,20.16,88.76,16.63,85.29z M38,94.4c-2.27,0-4.64-0.33-7.05-0.98
	l4.26-8.52l12.95,9.5H38z"
      />
    </svg>
  )
}

export default CushionDiamond
